// @flow

import * as React from 'react';

import { localize } from '@ta/common.i18n';

import styles from './ErrorSection.less';

const ErrorSection = () => (
  // TODO: copy + styling from design
  <div className={`ui_card section ${styles.section}`}>
    <span>Profile feed was partially loaded, try refreshing the page again</span>

    <span style={{ paddingLeft: '10px' }}>
      <button
        className="ui_button standard"
        onClick={e => {
          e.preventDefault();
          // eslint-disable-next-line no-restricted-globals
          window.location.reload();
        }}
      >
        {localize('link_uploader_refresh')} {/* Refresh */}
      </button>
    </span>
  </div>
);

export default ErrorSection;
